import {
  SET_LOGOUT_AUTH,
  USER_HAS_ADMIN_ROLE_AND_REPORTS_ENABLE
} from '../actions/Index';

interface ReportsStateTypes {
  user_has_admin_role_and_reports_enable: boolean;
}

const initState: ReportsStateTypes = {
  user_has_admin_role_and_reports_enable: false
};

export default function (state = initState, action: any): ReportsStateTypes {
  const {type, payload} = action;

  switch (type) {
    case USER_HAS_ADMIN_ROLE_AND_REPORTS_ENABLE:
      return {
        user_has_admin_role_and_reports_enable:
          payload.user_has_admin_role_and_reports_enable
      };
    case SET_LOGOUT_AUTH:
      return {
        ...initState
      };
    default:
      return state;
  }
}
